import type {
  PlatformLocation,
  PlatformOrderingConfig,
} from "@/lib/restaurant-platform";

/**
 * Check if the order feature is enabled
 * Set NEXT_PUBLIC_DISABLE_ORDER=true to disable the order feature
 */
export function isOrderFeatureEnabled(): boolean {
  return process.env.NEXT_PUBLIC_DISABLE_ORDER !== "true";
}

/**
 * When false (default), the storefront is pickup-only: no delivery toggle, no address gate.
 * Set NEXT_PUBLIC_ORDER_DELIVERY_ENABLED=true when delivery is fully wired (zones, fees, address).
 */
export function isDeliveryOrderingEnabled(): boolean {
  return process.env.NEXT_PUBLIC_ORDER_DELIVERY_ENABLED === "true";
}

export type OrderingFeatureConfig = PlatformOrderingConfig;

export function getOrderingFeatureConfig(
  location: PlatformLocation,
): OrderingFeatureConfig {
  return location.ordering;
}

export function isFirstPartyOrderingEnabledForLocation(
  location: PlatformLocation,
): boolean {
  if (!isOrderFeatureEnabled()) {
    return false;
  }

  return (
    location.ordering.mode === "first_party" &&
    location.ordering.pickupEnabled
  );
}

export function isMenuCartBrowsingEnabledForLocation(
  location: PlatformLocation,
): boolean {
  return (
    location.ordering.mode === "first_party" &&
    location.ordering.pickupEnabled
  );
}

export function isDeliveryOrderingEnabledForLocation(
  location: PlatformLocation,
): boolean {
  if (!isFirstPartyOrderingEnabledForLocation(location)) {
    return false;
  }

  return location.ordering.deliveryEnabled;
}
